import React from 'react'

const MixCal = ({ selectedStandardInfo }) => {
  return (
    <div
      className="w-full flex flex-col h-96 overflow-y-scroll"
      style={{ fontSize: '14px' }}
    >
      {selectedStandardInfo.map((item, index) => {
        const { type } = (item && item.field) || {}

        return (
          <div key={item.objectId} className="w-full flex flex-col gap-2 mb-2">
            <div className="w-full flex items-center">
              <b style={{ fontSize: '14px' }}>
                {index + 1}:{item.standard.title}
              </b>
              {type !== 'number' && (
                <span className="text-red-500">
                  !!不是数值类型，无法参与计算
                </span>
              )}
              {type === 'number' && !item.field && (
                <span className="text-red-500">!!暂未绑定，请先绑定</span>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default MixCal
